import React, { useContext, useEffect } from "react";
import { DatePicker } from "antd";
import { AppContext } from "../../context";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { EXPERIENCES } from "./experiencesConstants";
import { searchExperiences } from "./searchExperiences";
import moment from "moment";
import { searchExperienceStores } from "./searchExperienceStores";

function ExperienceFilter({ setStores }) {
  const info = useContext(AppContext);

  const handleChange = (type, value) => {
    info.setExperience({
      ...info.experience,
      [type]: value,
    });
  };

  useEffect(() => {
    (async () => {
      let experienceStores = await searchExperienceStores(info);
      setStores(experienceStores);
    })();
  }, [info.villages, info.name, info.experience, info.immediateConfirmation]);

  return (
    // <div style={{ display: "flex", flexWrap: "wrap" }}>
    <div className="ahp-service-filter">
      <div>
        <div style={{ display: "inline", marginTop: 6 }}>
          {info.t("people")}:
        </div>
        <AHPSelect
          label={info.t("people")}
          type="experience"
          field="people"
          options={EXPERIENCES.PEOPLE_OPTIONS}
          width={FIELD_WIDTHS.XS}
        />
      </div>

      <DatePicker
        disabledDate={(current) => current && current < moment()}
        style={{ width: FIELD_WIDTHS.M }}
        onChange={(value) => handleChange("date", value)}
        placeholder={info.t("date")}
        bordered={false}
        value={info.experience.date}
      />

      <AHPSelect
        label={info.t("type")}
        type="experience"
        field="category"
        options={EXPERIENCES.CATEGORIES.map((d) => ({
          value: d,
          label: info.t(d),
        }))}
        allowClear
      />

      <AHPSelect
        label={info.t("duration")}
        type="experience"
        field="duration"
        options={EXPERIENCES.DURATIONS.map((d) => ({
          value: d,
          label: info.t(d),
        }))}
        allowClear
      />
    </div>
  );
}

export default ExperienceFilter;
